<template>
    <main id="login" style="height: 100vh">
        <div class="container-fluid h-100">
            <b-row class="h-100">
                <b-col id="bg-side" md="12">
                    <LanguageSwitch />
                    <div class="loginCard">
                        <div id="logo" />
                        <b-form
                            style="max-width: 700px"
                            v-if="!passwordlessLoginToken"
                            class="d-flex login-form flex-column justify-content-center w-100"
                            @submit.prevent="doLogin"
                        >
                            <b-form-group
                                id="email-input-group"
                                :label="$t('message.yourEmail')"
                                label-for="email-input"
                            >
                                <b-form-input
                                    id="email-input"
                                    v-model="loginForm.email"
                                    v-validate="'required|email'"
                                    class="form-mail"
                                    name="email"
                                    placeholder=""
                                    trim
                                    type="email"
                                />
                                <span v-if="isSubmit" class="text-danger mt-3">{{ errors.first("email") }}</span>
                            </b-form-group>
                            <b-form-group
                                id="passowrd-input-group"
                                :label="$t('message.password')"
                                label-for="password-input"
                            >
                                <b-form-input
                                    id="password-input"
                                    v-model="loginForm.password"
                                    v-validate="'required'"
                                    class="mail"
                                    name="password"
                                    placeholder=""
                                    type="password"
                                />
                                <span v-if="isSubmit" class="text-danger mt-3">{{ errors.first("password") }}</span>
                            </b-form-group>
                            <b-button :disabled="loading" class="mt-4 login-btn" type="submit" variant="primary">
                                <span v-if="loading">
                                    <b-spinner small type="grow" />
                                </span>
                                <span v-else>
                                    {{ $t("message.login") }}
                                </span>
                            </b-button>
                            <a-divider class="text-light">{{ $t("message.or") }}</a-divider>

                            <div class="d-flex justify-content-center flex-column">
                                <b-button
                                    class="mt-4 login-btn-extra"
                                    type="button"
                                    variant="secondary"
                                    @click="() => $router.push('forgot-password')"
                                >
                                    {{ $t("message.lostPassword") }}
                                </b-button>
                                <b-button
                                    class="mt-4 login-btn-extra"
                                    type="button"
                                    variant="secondary"
                                    @click="() => $router.push('passwordless-login')"
                                >
                                    {{ $t("message.loginWithEmail") }}
                                </b-button>
                            </div>
                        </b-form>
                        <div v-else class="passwordless-login">
                            <div v-if="!passwordlessLoginUnsuccessful">
                                <md-progress-spinner
                                    :md-diameter="100"
                                    :md-stroke="10"
                                    md-mode="indeterminate"
                                ></md-progress-spinner>
                                <p class="mt-3 text-light">
                                    {{ $t("message.enteringPasswordless") }}
                                </p>
                            </div>
                            <div v-else class="login-error">
                                <h3>
                                    {{ $t("message.passwordlessLoginUnsuccessful") }}
                                </h3>
                                <b-button class="mt-4 login-btn-rr" variant="primary" @click="goBackToLogin">
                                    {{ $t("message.backToLogin") }}
                                </b-button>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>
    </main>
</template>

<script>
import { mapActions, mapState } from "vuex";
import PasswordForgot from "../../components/svg/PasswordForgot";
import log2 from "../../utils/log2";
import LanguageSwitch from "../../components/LanguageSwitch";

const log = log2("Login");
export default {
    name: "Login",
    components: { LanguageSwitch, PasswordForgot },

    data() {
        return {
            passwordlessLoginToken: this.$route.query.passwordlessLoginToken,
            forceResetPassword: this.$route.query.forceResetPassword === "true",
            emailFromQuery: decodeURIComponent(this.$route.query.email),
            loading: false,
            isSubmit: false,
            passwordlessLoginUnsuccessful: false,
            loginForm: {
                email: "",
                password: "",
            },
        };
    },
    methods: {
        ...mapActions({
            login: "auth/login",
            passwordlessLogin: "auth/passwordlessLogin",
        }),
        goBackToLogin() {
            this.passwordlessLoginToken = null;
            this.emailFromQuery = null;
            this.$router.push("login");
        },
        doLogin() {
            this.isSubmit = true;
            this.$validator.validateAll().then((response) => {
                if (response) {
                    this.loading = true;
                    this.login(this.loginForm)
                        .then((loggedUser) => {
                            this.$router.push("/");
                        })
                        .catch((err) => {
                            console.error(err);
                            const errMsg =
                                err.response && err.response.data && err.response.data.localizedMessages
                                    ? err.response.data.localizedMessages[this.$i18n.locale]
                                    : err.message;
                            const trTimeout = "İstek zaman aşımına uğradı";
                            const enTimeout = "The request timed out";
                            const langTimeout = this.language.code === "tr" ? trTimeout : enTimeout;
                            if (errMsg === "timeout of 20000ms exceeded" ? langTimeout : errMsg) {
                                this.$bvToast.toast(errMsg, {
                                    title: this.$t("message.error"),
                                    variant: "danger",
                                    solid: true,
                                });
                            }
                        })
                        .finally(() => (this.loading = false));
                }
            });
        },
        doPasswordlessLogin() {
            if (this.passwordlessLoginToken && this.emailFromQuery) {
                this.loading = true;
                this.passwordlessLogin({
                    email: this.emailFromQuery,
                    passwordlessLoginToken: this.passwordlessLoginToken,
                })
                    .then((loggedUser) => {
                        const url = this.forceResetPassword
                            ? `/?ptoken=${this.passwordlessLoginToken}&forceResetPassword=${this.forceResetPassword}`
                            : `/`;
                        this.$router.push(url);
                    })
                    .catch((err) => {
                        console.error(err);
                        let errMsg =
                            this.language.code === "en"
                                ? _.get(err, "response.data.localizedMessages.en")
                                : _.get(err, "response.data.localizedMessages.tr");
                        errMsg = errMsg || "An error occured";
                        this.$bvToast.toast(errMsg, {
                            title: this.$t("message.error"),
                            variant: "danger",
                            solid: true,
                        });
                        this.passwordlessLoginUnsuccessful = true;
                    })
                    .finally(() => (this.loading = false));
            }
        },
    },
    computed: {
        location() {
            return document.location.hostname;
        },
        ...mapState({
            site: (state) => state.site.site,
            language: (state) => state.language.language,
            languages: (state) => state.language.languages,
        }),
    },
    watch: {
        site(newValue) {
            if (newValue && newValue._id) {
                this.doPasswordlessLogin();
            }
        },
    },
    mounted() {
        if (this.site) {
            this.doPasswordlessLogin();
        }
    },
};
</script>

<style lang="scss" scoped>
.passwordless-login {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin: 5px;
}

.login-error {
    margin: 2em;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

h3 {
    margin: 2em;
    color: #ffffff;
}

.login-btn-rr {
    border-radius: 30.5px;
    background-color: #48b6e7;
    margin: 2em;
    border: none !important;
}
</style>
